import React, { useState } from 'react';
import { Button, Col, Form, message } from 'antd';
import { BookyInput, InputType } from '../../Forms/BookyInput';
import { BookySelectDropDown } from '../../Forms/BookySelectDropDown';
import { BookyButton } from '../../Buttons/BookyButton';
import { TextService } from '../../../Services/TextService';
import { IntegrationService } from '../../../Services/IntegrationService';
import { getCurrentYearAsOption } from '../../../Helpers/PaymentYearOptions';
import { getPreviousYear } from '../../../Helpers/DateHelpers';

interface AddPaymentLinkFormProps {
    memberId: number;
    onLinkCreated: () => void;
    onCancel: () => void;
}

const AddPaymentLinkForm = ({ memberId, onLinkCreated, onCancel }: AddPaymentLinkFormProps) => {
    const [form] = Form.useForm();
    const GetText = TextService.GetText;
    const [isCreating, setIsCreating] = useState(false);

    const handleCreate = async () => {
        try {
            setIsCreating(true);
            await IntegrationService.CreatePaymentLink({
                memberId: memberId,
                description: form.getFieldValue("description").toString(),
                amount: form.getFieldValue("amount"),
                paymentType: 1,
                connectedYear: form.getFieldValue("year").toString(),
            });
            message.success(GetText("ManagePayments_PaymentLinkCreated"));
            form.resetFields();
            onLinkCreated();
        } catch {
            message.warning(GetText("EditMember_ErrorSaving"));
        } finally {
            setIsCreating(false);
        }
    };

    return (
        <div style={{ marginTop: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <h4 style={{ margin: 0 }}>{GetText("ManagePayments_AddPaymentLinkTitle")}</h4>
                <Button type="link" size="small" onClick={onCancel}>
                    {GetText("AddPaymentLink_CollapseForm")}
                </Button>
            </div>
            <Form form={form} colon={false} labelAlign="left" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}
                initialValues={{ year: getPreviousYear(0) }}
            >
                <Col span={17}>
                    <BookyInput label={GetText("AddPayment_Description")} onClick={handleCreate} name="description" requiredMessage={GetText("AddPaymentLink_DescriptionRequired")} placeholder={GetText("AddPaymentLink_DescriptionPlaceholder")} />
                    <BookyInput type={InputType.number} label={GetText("AddPayment_NoteColumnPlaceHolder")} requiredMessage={GetText("AddPaymentLink_AmountRequired")} onClick={handleCreate} name="amount" req placeholder={GetText("AddPayment_NoteColumnPlaceHolder")} />
                    <BookySelectDropDown label={GetText("AddPayment_YearColumn")} name="year" options={getCurrentYearAsOption()} />
                    <Form.Item label={" "}>
                        <BookyButton type="primary" fullWidth={false} text={GetText("AddPaymentLink_CreateButton")} onClick={handleCreate} loading={isCreating} />
                    </Form.Item>
                </Col>
            </Form>
        </div>
    );
};

export default AddPaymentLinkForm;
